import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/stockBunk',
  component: Layout,
  name: 'stockBunk',
  redirect: '/stockBunk/index',
  children: [{
    path: '/stockBunk/index',
    component: () => import('@/views/stockBunk/index'),
    name: 'stockBunk.index',
    meta: {
      title: i18n.t(`message.income_product`)
    }
  }, ]
}

export default schedule